import Soporte from './pages/Soporte';
import React, { useCallback, useState } from 'react';
import { ProveedorAutenticacion, useAutenticacion } from './context/AuthContext';
import { ProveedorPacientes, usePacientes } from './context/PatientsContext';
import { ThemeProvider } from './context/ThemeContext';
import Distribucion from './components/Layout';
import InicioSesion from './pages/Login';
import PanelPrincipal from './pages/Dashboard';
import Pacientes from './pages/Patients';
import DetallePaciente from './pages/PatientDetail';
import AltaPacientes from './pages/AltaPacientes';
import Asistencias from './pages/Attendances';
import Agendas from './pages/Agendas';
import Equipo from './pages/Equipo';
import Profesionales from './pages/Profesionales';
import Users from './pages/Users';
import UserHistory from './pages/UserHistory';
import Admision, { Expedientes } from './pages/Admision';
import Facturacion from './pages/Facturacion';
import Informes from './pages/Informes';
import { canOpenPage, firstAllowedPage } from './utils/modulePermissions';

function CapaApp() {
  const { usuario, cargando, cerrarSesion } = useAutenticacion();
  const { seleccionarPaciente, cargandoDetalle, detallePacienteListo } = usePacientes();
  const [pagina, setPagina] = useState('dashboard');
  const [moduloSoporte, setModuloSoporte] = useState('general');
  const [ticketSeleccionado, setTicketSeleccionado] = useState(null);
  const [paginaAnterior, setPaginaAnterior] = useState('dashboard');

  const navegar = useCallback((siguiente) => {
    setTicketSeleccionado(null);
    if (siguiente === 'support') setModuloSoporte(({ dashboard: 'listado_pacientes', patients: 'buscador', admision: 'admision', facturacion: 'facturacion', expedientes: 'expedientes', reports: 'informes', attendances: 'asistencias' })[pagina] || 'general');
    if (canOpenPage(usuario, siguiente)) setPagina(siguiente);
  }, [usuario, pagina]);

  const abrirPaciente = useCallback((id) => {
    if (!canOpenPage(usuario, 'patient')) return;
    seleccionarPaciente(id);
    setPaginaAnterior(pagina);
    setPagina('patient');
  }, [pagina, seleccionarPaciente, usuario]);

  const volver = useCallback(() => {
    setPagina(canOpenPage(usuario, paginaAnterior) ? paginaAnterior : firstAllowedPage(usuario));
  }, [paginaAnterior, usuario]);

  const paginaVisible = usuario && canOpenPage(usuario, pagina) ? pagina : firstAllowedPage(usuario);

  const renderContenido = () => {
    if (cargando) {
      return <div style={{ padding: 24 }}>Cargando...</div>;
    }
    if (!usuario) return <InicioSesion alIngresar={() => setPagina('dashboard')} />;
    if (!paginaVisible) return <div className="p-8">No tienes módulos asignados. Consulta al administrador.</div>;
    if (paginaVisible === 'support') return <Soporte key={ticketSeleccionado || 'list'} usuario={usuario} moduloInicial={moduloSoporte} ticketInicial={ticketSeleccionado} />;
    if (paginaVisible === 'dashboard') return <PanelPrincipal alAbrirPaciente={abrirPaciente} />;
    if (paginaVisible === 'patients') return <Pacientes alAbrirPaciente={abrirPaciente} />;
    if (paginaVisible === 'alta') return <AltaPacientes alAbrirPaciente={abrirPaciente} />;
    if (paginaVisible === 'attendances') return <Asistencias alCrearPaciente={() => navegar('alta')} />;
    if (paginaVisible === 'agendas') return <Agendas usuario={usuario} alAbrirPaciente={canOpenPage(usuario, 'patient') ? abrirPaciente : null} />;
    if (paginaVisible === 'equipo') return <Equipo usuario={usuario} />;
    if (paginaVisible === 'profesionales' && usuario?.isAdmin) return <Profesionales />;
    if (paginaVisible === 'users' && usuario?.isAdmin) return <Users />;
    if (paginaVisible === 'user-history' && usuario?.isAdmin) return <UserHistory />;
    if (paginaVisible === 'admision') {
      return <Admision alAbrirPaciente={abrirPaciente} alNavegar={navegar} />;
    }
    if (paginaVisible === 'expedientes') return <Expedientes />;
    if (paginaVisible === 'facturacion') return <Facturacion />;
    if (paginaVisible === 'reports') return <Informes />;
    if (paginaVisible === 'patient') {
      if (!detallePacienteListo) return <div className="p-8">
        <p>{cargandoDetalle ? 'Cargando ficha del paciente...' : 'No se pudo cargar la ficha del paciente.'}</p>
        {!cargandoDetalle && <button type="button" onClick={volver} className="mt-4 rounded-xl border px-4 py-2">Volver</button>}
      </div>;
      return <DetallePaciente alVolver={volver} soloLectura={!canOpenPage(usuario, 'patient-edit')} />;
    }
    return <PanelPrincipal />;
  };
  const contenido = renderContenido();

  return (
    <Distribucion
      paginaActual={paginaVisible}
      alNavegar={navegar}
      usuario={usuario}
      alAbrirTicket={id => { setTicketSeleccionado(id); setPagina('support'); }}
      alCerrarSesion={() => {
        cerrarSesion();
        setPagina('dashboard');
      }}
    >
      {contenido}
    </Distribucion>
  );
}

export default function Aplicacion() {
  return (
    <ThemeProvider>
      <ProveedorAutenticacion>
        <ProveedorPacientes>
          <CapaApp />
        </ProveedorPacientes>
      </ProveedorAutenticacion>
    </ThemeProvider>
  );
}
